import { IError, IQueryHookOptions } from '@comptia-sso/core';
import { UseMutateAsyncFunction, useMutation } from 'react-query';

// Services.
import { setPassword } from 'services';

// Types.
import { ISetPasswordRequest } from 'types';

type SetPasswordFunction = UseMutateAsyncFunction<
  void,
  unknown,
  ISetPasswordRequest
>;

type UseSetPassword = [SetPasswordFunction, IQueryHookOptions];

export const useSetPassword = (id = ''): UseSetPassword => {
  const { error, isError, isLoading, mutateAsync } = useMutation<
    void,
    IError,
    ISetPasswordRequest
  >((values: ISetPasswordRequest) => setPassword(id, values));

  return [mutateAsync, { error, isError, isLoading }];
};
